// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var jQueryEventWithSample = function (dictMonadFRP) {
    return function (sample) {
        return function (eventType) {
            return function (node) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (v) {
                    var handler = Control_Bind.composeKleisli(Effect.bindEffect)(sample)(v.fire);
                    return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())($foreign.addEventListener(eventType)(handler)($foreign.fromNode(node))))(function (unsub) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Cleanup.onCleanup(dictMonadFRP.MonadCleanup1())(unsub))(function () {
                            return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(v.event);
                        });
                    });
                });
            };
        };
    };
};
export {
    addEventListener,
    fromNode
} from "./foreign.js";
export {
    jQueryEventWithSample
};
//# sourceMappingURL=index.js.map
